import React from 'react';
import { isTerminalVertical } from '../../utils';
import { UNIT, COLOR_LIGHT_GRAY } from '../../constants/configuration';

const ModalBorder = ({
  children,
  color = COLOR_LIGHT_GRAY,
  className,
  style = {},
  id,
  onScroll
}) => {
  return (
    <div
      className={`dishop-iso ${className}`}
      style={{
        border: `${isTerminalVertical() ? '6px' : '3px'} solid ${color}`,
        borderRadius: UNIT * 2,
        ...style
      }}
      id={id}
      onScroll={onScroll}
    >
      {children}
    </div>
  );
};

export default ModalBorder;
